var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_90937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.5312C24.5777 31.5312 31.5312 24.5777 31.5312 16C31.5312 7.42233 24.5777 0.46875 16 0.46875C7.42233 0.46875 0.46875 7.42233 0.46875 16C0.46875 24.5777 7.42233 31.5312 16 31.5312Z",
    fill: "#4956FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28.4062C22.8518 28.4062 28.4062 22.8518 28.4062 16C28.4062 9.14822 22.8518 3.59375 16 3.59375C9.14822 3.59375 3.59375 9.14822 3.59375 16C3.59375 22.8518 9.14822 28.4062 16 28.4062Z",
    fill: "#5E8DF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8376 15.2575L20.8663 15.8088L15.9282 17.6725L10.1626 15.2575L15.9282 5.3775L21.8376 15.2575Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8376 15.2575L15.9282 18.61L10.1626 15.2575L15.9282 12.5656L21.8376 15.2575Z",
    fill: "#C0CBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8376 17.615L15.9282 26.6225L10.1626 17.615L15.9282 20.9669L21.8376 17.615Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8376 17.615L15.9282 26.6225V20.9669L21.8376 17.615ZM21.8376 15.2575L20.8663 15.8088L15.9282 12.985V5.3775L21.8376 15.2575Z",
    fill: "#C0CBF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8376 15.2575L15.9282 18.61V12.5656L21.8376 15.2575Z",
    fill: "#8095F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_90937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth.13beb07d82628f36f657373bdf68ebb5.svg";